/**
 * Next.js client instrumentation — runs after the document loads and before
 * React hydrates, which is the only window in which the browser SDK's
 * fetch/XHR patches are guaranteed to be in place before the page's own
 * requests go out. Every call here is synchronous for that reason.
 *
 * Reads the Browser configuration from `NEXT_PUBLIC_ONEUPTIME_*` (inlined at
 * build time). When those are absent, `initBrowserTelemetry()` is a no-op and
 * nothing is patched or sent.
 *
 * @module instrumentation-client
 */

import { initBrowserTelemetry, startRouteChange } from '@/lib/observability/browser'

initBrowserTelemetry()

/**
 * Next's App Router navigation hook: one span per navigation, labelled with the
 * route pattern rather than the concrete URL.
 */
export function onRouterTransitionStart(
  url: string,
  navigationType: 'push' | 'replace' | 'traverse',
): void {
  startRouteChange(url, navigationType)
}
